import React from 'react'
import { Table, Menu, ActionIcon } from '@mantine/core'
import { IconDotsVertical, IconTrash, IconPencil, IconPhoto} from '@tabler/icons-react'
import { decimalFormat, thousandFormat, decimalCheck } from '../../../../../../plugins/addons'

const ActionMenu = ({ handleAction }) => {
  return (
    <Menu width={180} position="bottom-end" withArrow arrowPosition="center">
      <Menu.Target>
        <ActionIcon ml={10} mt={6} variant='transparent' size='sm' color='rgba(0, 0, 0, 1)'>
          <IconDotsVertical stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconPencil stroke={1.5} size={18} />}
          onClick={() => handleAction('edit')}
          fw='600'
          fz={12}
        >
          Edit
        </Menu.Item>
        <Menu.Item
          leftSection={<IconPhoto stroke={1.5} size={18} />}
          onClick={() => handleAction('attach')}
          fw='600'
          fz={12}
        >
          Lampiran Gambar
        </Menu.Item>
        <Menu.Item
          color='red'
          leftSection={<IconTrash stroke={1.5} size={18} />}
          onClick={() => handleAction('delete')}
          fw='600'
          fz={12}
        >
          Hapus
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}

const TableReportParams = ({ label, data, actionMethod }) => {
  const mappingTableHead = (data) => data.map((val, index) => {
    return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
  })

  const mappingIsProductionParams = (val) => {
    if (!val.parameter.aspect.isProduction) {
      return (<Table.Td>{val.intensity ? decimalCheck(val.intensity) ? thousandFormat(val.intensity) : decimalFormat(val.intensity) : 0} {val.parameter.unit.symbol} / {val.parameter.divider.unit.symbol}</Table.Td>)
    } else {
      return (<Table.Td>-</Table.Td>)
    }
  }

  const mappingDataTable = data => data.map((val, index) => {
    return (
      <Table.Tr key={index}>
        <Table.Td>{index + 1}.</Table.Td>
        <Table.Td>{val.parameter.name}</Table.Td>
        <Table.Td>{val.parameter.aspect.name ? val.parameter.aspect.name : '-'}</Table.Td>
        <Table.Td>{decimalCheck(val.value) ? thousandFormat(val.value) : decimalFormat(val.value)} {val.unitConversion === null ? val.parameter.unit.symbol : val.unitConversion.name}</Table.Td>
        <Table.Td>{val.finalValue ? decimalCheck(val.finalValue) ? thousandFormat(val.finalValue) : decimalFormat(val.finalValue) : 0} {val.parameter === null ? '' : val.parameter.unit.symbol}</Table.Td>
        {mappingIsProductionParams(val)}
        <Table.Td><ActionMenu handleAction={(type) => actionMethod(val, type)} /></Table.Td>
      </Table.Tr>
    )
  })
  return (
    <Table.ScrollContainer minWidth={768}>
      <Table horizontalSpacing='sm' withTableBorder style={{ fontSize: '13px' }}>
        <Table.Thead>
          <Table.Tr>
            {mappingTableHead(label)}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {mappingDataTable(data)}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  )
}

export default TableReportParams